import { render, staticRenderFns } from "./SetRating.vue?vue&type=template&id=390c5e4a"
import script from "./SetRating.vue?vue&type=script&lang=js"
export * from "./SetRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports